import React from 'react';

const BadgeSelector = ({ currentBadge, onChange }) => {
  const badges = [
    { level: 0, name: 'No Badge' },
    { level: 1, name: 'Bronze' },
    { level: 2, name: 'Silver' },
    { level: 3, name: 'Gold' }
  ];

  return (
    <div className="badge-selector">
      <div className="badge-options">
        {badges.map((badge) => (
          <button
            key={badge.level}
            className={`badge-option ${currentBadge === badge.level ? 'selected' : ''} badge-${badge.name.toLowerCase()}`}
            onClick={() => onChange(badge.level)}
            title={badge.name}
          >
            {badge.name}
          </button>
        ))}
      </div>
    </div>
  );
};

export default BadgeSelector;